import router from '@/routes'

export const RouterMixin = {
  methods: {
    navigate(route) {
      router.push(route).catch(err => {})
    },
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.navigate({path: '/'})
    },
    goHome() {
      this.navigate({name: 'home'})
    }
  }
}
